import { Facebook, Instagram, Star } from "lucide-react";

export function SocialRail({ socials = {} }) {
  const items = [
    { key: "facebook", url: socials.facebook, Icon: Facebook, label: "Facebook" },
    { key: "instagram", url: socials.instagram, Icon: Instagram, label: "Instagram" },
    { key: "google", url: socials.google, Icon: Star, label: "Leave a review" },
  ].filter((i) => i.url && i.url.trim());

  if (!items.length) return null;

  return (
    <div
      data-testid="social-rail"
      className="fixed left-3 md:left-5 top-1/2 -translate-y-1/2 z-40 flex flex-col gap-3"
    >
      {items.map(({ key, url, Icon, label }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
          data-testid={`social-${key}`}
          className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-background border-2 border-foreground shadow-brutal flex items-center justify-center hover:bg-secondary hover:text-secondary-foreground hover:-translate-y-0.5 transition-all"
        >
          <Icon size={18} />
        </a>
      ))}
    </div>
  );
}
